<template>
  <div
    :class="cssClasses()"
    class="switch-wrapper"
  >
    <input
      :id="id"
      v-model="value"
      :name="name"
      :value="inputValue1"
      checked
      type="radio"
      @click="click"
    >
    <label
      :for="id"
      :data-test="`${dataTest}-switch-1`"
    >
      {{ label1 }}
    </label>

    <input
      :id="`${id}2`"
      v-model="value"
      :name="name"
      :value="inputValue2"
      type="radio"
      @click="click"
    >
    <label
      :for="`${id}2`"
      :data-test="`${dataTest}-switch-2`"
    >
      {{ label2 }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioSwitch',
  props: {
    id: {
      type: String,
      default() {
        return this._uid.toString() // eslint-disable-line no-underscore-dangle
      },
    },
    label1: {
      type: String,
      default: '',
    },
    label2: {
      type: String,
      default: '',
    },
    dataTest: {
      type: String,
      default: '',
    },
    name: {
      type: [String],
      default: 'defaultRadioName',
    },
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    inputValue1: {
      type: [String, Number, Boolean],
      default: '',
    },
    inputValue2: {
      type: [String, Number, Boolean],
      default: '',
    },
  },
  methods: {
    cssClasses () {
      return {
        error: this.error,
      }
    },
    click (event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "styles/index";
</style>
